import { doc } from 'config/environment';
import getblcktiveContext from 'shared/getblcktiveContext';
import { isString } from 'utils/is';

const query = doc && doc.querySelector;

export default function getContext(node) {
  if (isString(node) && query) {
    node = query.call(document, node);
  }

  let instances;
  if (node) {
    if (node._blcktive) {
      return node._blcktive.proxy.getContext();
    } else if ((instances = node.__blcktive_instances__)) {
      if (instances.length === 1) return getblcktiveContext(instances[0]);
    } else return getContext(node.parentNode);
  }
}
